import React, { Component, Fragment } from 'react';
import { Breadcrumbs, Modal, Paper, Typography, withStyles, Dialog } from '@material-ui/core';
import MaterialTable from 'material-table';
import { Query, withApollo } from "react-apollo";
import { organizadorSessoesAgendadasListQuery, gerenciarSessoesArquivarMutation, gerenciarSessoesRestaurarMutation } from '../../graphql/Sessao';
import autoBind from 'react-autobind';
import { Button, Row, Col, ButtonToolbar, Form } from 'react-bootstrap';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import RemoveRedEyeOutlinedIcon from '@material-ui/icons/RemoveRedEyeOutlined';
import LinkOutlinedIcon from '@material-ui/icons/LinkOutlined';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import UndoOutlinedIcon from '@material-ui/icons/UndoOutlined';
import SessaoForm from '../../widgets/organizador/sessao-form/sessaoForm';
import moment from 'moment-timezone';
import Link from '@material-ui/core/Link';
import { Link as RouterLink } from 'react-router-dom';
import Environment from "../../environment/environment";
import ExibirLinkAcesso from './popup/exibir-link-acesso';
import Swal from 'sweetalert2';

const { Group } = Form;

const styles = theme => ({
    button: {
        margin: theme.spacing(1),
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
    root: {
        padding: theme.spacing(3, 2),
        maxWidth: '100%'
    },
    modalWrapper: {
        display: 'flex',
        justifyContent: 'center'
    },
});

class AdmGerenciarSessoes extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showExibirLinkAcessoModal: false,
            verArquivados: false,
            definicaoSelecionada: null,
            showModal: false,
            id: null
        }

        autoBind(this);
    }

    handleShowModal(id, action) {
        this.setState({
            showModal: true,
            id: id || null,
            action
        });
    }

    handleModalClose() {
        this.setState({
            showModal: false,
            id: null
        });

        this.doRefetch();
    }

    doRefetch() {
        if (!this._queryRefetch)
            return;

        this.props.client.clearStore().then (
            () => this._queryRefetch(this._queryVariables ? { variables: this._queryVariables } : {})
        ) ;
    }

    render() {
        const {  id, showModal } = this.state;
        const { classes, sessaoFormExibirSessaoAvancado } = this.props;

        return (
            <Paper className={classes.root}>
                {this.renderBreadCrumb()}
                {this.renderBotoesSuperiores()}
                {this.renderGridPrincipal()}
                {this.defineExibirLinkAcessoModal()}

                { showModal ? (
                        <Dialog
                            aria-labelledby="simple-modal-title"
                            aria-describedby="simple-modal-description"
                            open={showModal}
                            onClose={this.handleModalClose}
                            fullScreen
                        >
                            <Paper className={[classes.root, classes.novaSessaoWrapper].join(' ')}>
                                <SessaoForm id={id} action={this.state.action} handleModalClose={this.handleModalClose} exibirSessaoAvancado={sessaoFormExibirSessaoAvancado} />
                            </Paper>
                        </Dialog>
                    ) : null }

            </Paper>
        );
    }

    renderBreadCrumb() {
        return (
            <Breadcrumbs aria-label="Breadcrumb" className="bradcrumbs">
                <Typography >Organizar</Typography>
                <Typography >Gerenciar Sessões</Typography>
                <div>Agendadas</div>
            </Breadcrumbs>
        );
    }

    renderGridPrincipal() {
        this._queryVariables = {
            arquivado: this.state.verArquivados
        };

        const actions = this.geraActions();

        return (
            <Query query={organizadorSessoesAgendadasListQuery} variables={{ ...this._queryVariables }} fetchPolicy='network-only'>
                {({ data, loading, error, refetch }) => {
                    if (loading) return 'Loading...'
                    if (error) return `Error! ${error.message}`
                    this._queryRefetch = refetch;

                    return (
                        <MaterialTable
                            actions={actions}
                            columns={[
                                { title: "ID", field: "id" },
                                { title: "Sessão", field: "nome" },
                                { title: "Início", field: "inicio", render: rowData => Environment.momentToLocalDateAndTimeString(rowData.inicio) },
                                { title: "Fim", field: "fim", render: rowData => Environment.momentToLocalDateAndTimeString(rowData.fim) },
                            ]}
                            data={data.organizadorSessoesAgendadasList}
                            localization={{
                                body: {
                                    emptyDataSourceMessage: 'Nenhuma sessão encontrada'
                                },
                                header: {
                                    actions: 'Ações'
                                },
                                toolbar: {
                                    searchPlaceholder: 'Pesquisar',
                                    searchTooltip: 'Pesquisar'
                                }
                            }}
                            options={{
                                actionsColumnIndex: -1,
                                paging: false,
                                draggable: false
                            }}
                            title={
                                this.state.verArquivados ? "Sessões (canceladas)" : "Sessões"
                            }
                        />
                    );
                }}
            </Query>
        );
    }

    renderBotoesSuperiores() {
        const { classes } = this.props;

        return (
            <Group className="btn-bar">
                <ButtonToolbar>

                    <Link
                        className={`${classes.button} btn btn-primary-get`}
                        component={RouterLink}
                        to="/org-nova-sessao">
                        Nova Sessão
                    </Link>

                    {
                        this.state.verArquivados !== true
                            ? <Button
                                variant="secondary"
                                className={`${classes.button} btn-secondary-get`}
                                onClick={() => this.setState({ verArquivados: true })}
                            >
                                Canceladas
                            </Button>
                            : <Button
                                variant="secondary"
                                className={`${classes.button} btn-secondary-get`}
                                onClick={() => this.setState({ verArquivados: false })}
                            >
                                Sair de Canceladas
                            </Button>
                    }
                </ButtonToolbar>
            </Group>
        );
    }

    geraActions() {
        const actions = [];
        const somenteLeitura = false;

        actions.push({
            icon: LinkOutlinedIcon,
            tooltip: 'Ver Link de Acesso',
            onClick: (event, rowData) => {
                this.handleShowExibirLinkAcessoModal(rowData.id);
            }
        });

        // Botão de arquivar ou restaurar
        if (this.state.verArquivados) {
            actions.push({
                hidden: somenteLeitura,
                icon: UndoOutlinedIcon,
                tooltip: 'Restaurar',
                onClick: (event, rowData) => {
                    this.props.client.mutate({
                        mutation: gerenciarSessoesRestaurarMutation,
                        variables: {
                            id: rowData.id
                        }
                    }).then(() => this.doRefetch());
                }
            });
        } else {
            actions.push({
                hidden: somenteLeitura,
                icon: DeleteOutlinedIcon,
                tooltip: 'Cancelar',
                onClick: (event, rowData) => {
                    Swal.fire({
                        title: "Cancelar sessão",
                        text: "Tem certeza que deseja cancelar esta sessão?",
                        icon: "question",
                        confirmButtonColor: "#5d5d5d",
                        showCancelButton: true,
                        focusConfirm: false,
                        confirmButtonText:
                            '<i class="fa fa-thumbs-up"></i> Cancelar sessão',
                        cancelButtonText:
                            '<i class="fa fa-thumbs-down"></i> Não',
                        cancelButtonAriaLabel: 'Thumbs down'
                    }).then(
                        (result) => {
                            if (result.value) {
                                this.props.client.mutate({
                                    mutation: gerenciarSessoesArquivarMutation,
                                    variables: {
                                        id: rowData.id
                                    }
                                }).then(() => this.doRefetch())
                            }
                        }
                    )
                }
            });

            actions.push({
                hidden: somenteLeitura,
                icon: EditOutlinedIcon,
                tooltip: 'Editar',
                onClick: (event, rowData) => this.handleShowModal(rowData.id, 'edit')
            });
        }

        return actions;
    }

    handleShowExibirLinkAcessoModal(sessionId) {
        this.setState({
            showExibirLinkAcessoModal: true,
            sessionId
        });
    }

    handleCloseExibirLinkAcessoModal() {
        this.setState({
            showExibirLinkAcessoModal: false,
            sessionId: null,
        });
    }

    defineExibirLinkAcessoModal() {
        const { showExibirLinkAcessoModal, sessionId } = this.state;
        const { classes } = this.props;
        return (
            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={showExibirLinkAcessoModal}
                onClose={this.handleClose}
                className={classes.modal}
            >
                <div className={classes.modalWrapper}>
                    <Paper className={classes.root}>
                        <ExibirLinkAcesso
                            sessionId={sessionId}
                            handleModalClose={this.handleCloseExibirLinkAcessoModal} />
                    </Paper>
                </div>
            </Modal>
        );
    }

}

export default (withStyles(styles)(withApollo(AdmGerenciarSessoes)));